module.exports = __webpack_public_path__ + "static/pool-a-6fa4cea237669c0932ac2da676b74594.svg";